export default {
  buildTime: '2026-06-04T16:40:37Z',
  commit: '7209297e7290e011e7ca886b17eb613f6061eb93',
  npmInfo: {
    'mashlib': '2.2.2',
    'npm': '10.9.8',
    'node': '22.22.3',
    'acorn': '8.16.0',
    'ada': '2.9.2',
    'amaro': '1.1.8',
    'ares': '1.34.6',
    'brotli': '1.1.0',
    'cjs_module_lexer': '2.2.0',
    'cldr': '48.0',
    'icu': '78.2',
    'llhttp': '9.3.1',
    'modules': '127',
    'napi': '10',
    'nbytes': '0.1.3',
    'ncrypto': '0.0.1',
    'nghttp2': '1.64.0',
    'openssl': '3.5.6',
    'simdjson': '4.5.0',
    'simdutf': '6.4.2',
    'sqlite': '3.51.3',
    'tz': '2026a',
    'undici': '6.24.1',
    'unicode': '17.0',
    'uv': '1.51.0',
    'uvwasi': '0.0.23',
    'v8': '12.4.254.21-node.56',
    'zlib': '1.3.1-e00f703',
    'zstd': '1.5.7',
  }
}
